import { memo } from 'react';
import { useTheme } from '@mui/material/styles';
import { useAuthContext } from 'src/auth/hooks';
import { useTenant } from 'src/auth/context/firebase/TenantContext';
import { NavSectionHorizontal } from 'src/components/nav-section';
import { useNavData } from './config-navigation';

function NavHorizontal() {
  const theme = useTheme();
  const { user } = useAuthContext();
  const { selectedTenant } = useTenant();
  const navData = useNavData();

  return (
    <NavSectionHorizontal
      data={navData}
      slotProps={{
        currentRole: user?.role,
        user,
        selectedTenant,
      }}
      sx={{
        display: 'flex',
        justifyContent: 'center', 
        width: '100%',
        ...theme.mixins.toolbar,
      }}
    />
  );
}

export default memo(NavHorizontal);
